export class VehOnhold {
  ptoEmision: string | null;
  vinLetras: string | null;
  vinNumeros: string | null;
  nroRemito: number | null;
  nroRemitoRowNum: number;
  codDestino: string | null;
  nombreDestino: string | null;
  codTransp: string | null;
  nombreTransp: string | null;
  chargeToCode: string | null;
  chargeToName: string | null;
  fecGen: Date | null;
  estadoRemito: string;
  impresoras: string;
  isInvalid: boolean;
  invoiceLetter: string | null;
  invoiceNum: string | null;
  invoicePto: string | null;
  invoiceDate: string | null;
  billingType: string | null;

  /**
   * Adapted from ReportRemito.ts - see comment there for explanation
   * @param data The data received from HttpClient.
   */
  static transformData(data: any): VehOnhold {
    let vehOnholdData = new VehOnhold();
    vehOnholdData.ptoEmision = data.ptoEmision;
    vehOnholdData.nroRemito = data.nroRemito;
    vehOnholdData.vinLetras = data.vinLetras;
    vehOnholdData.vinNumeros = data.vinNumeros;
    vehOnholdData.fecGen = data.fecGen != null ? new Date(data.fecGen) : null;
    vehOnholdData.codDestino = data.codDestino;
    vehOnholdData.nombreDestino = data.nombreDestino;
    vehOnholdData.chargeToCode = data.chargeToCode;
    vehOnholdData.chargeToName = data.chargeToName;
    vehOnholdData.estadoRemito = data.estadoRemito;
    vehOnholdData.impresoras = data.impresoras;
    vehOnholdData.invoiceLetter = data.invoiceLetter;
    vehOnholdData.invoiceNum = data.invoiceNum != null ? data.invoiceNum.toString().padStart(8, "0") : null;
    vehOnholdData.invoicePto = data.invoicePto;
    vehOnholdData.invoiceDate = data.invoiceDate;
    vehOnholdData.billingType = data.billingType;

    return vehOnholdData;
  }
}
